<template>
    <div id="app">
        <HeaderComponent />
        <router-view />
        <FooterComponent />
        <a
            href="#"
            style="position: fixed; bottom: 1rem ; right: 1rem ; z-index: 9990;"
            title="お問い合わせ"
            @click="$root.$emit('showInquiryModal')"
        >
            <img
                style="width: 2rem; height: 2rem; "
                src="@/assets/img/contact.svg"
                alt="お問い合わせ"
            >
        </a>
        <InquiryModal />
    </div>
</template>

<script>
import HeaderComponent from '@/components/Header'
import FooterComponent from '@/components/Footer'
import NoSleep from 'nosleep.js'
import { sleep } from './sleep'
import InquiryModal from '@/components/InquiryModal.vue'
import { store } from '@/store.js'

export default {
    name: 'App',
    components: { InquiryModal, FooterComponent, HeaderComponent },
    data () {
        return {
            uploadGroups: [],
            uploads: [],
            uploading: false,
            noSleep: new NoSleep()
        }
    },
    watch: {
        uploading (val) {
            if (val) {
                console.log('Try to prevent sleep')
                this.noSleep.enable()
                sleep.prevent()
            } else {
                console.log('Allow sleep')
                this.noSleep.disable()
                sleep.allow()
            }
        }
    },
    created () {
        const user = this.$ls.get('user')
        if (user) {
            store().setUser(user)
        }
        this.$root.$on('loading', this.loading)
        this.$root.$on('wake', this.wake)
        this.$http.head('maintenance').then((r) => {
            console.log(r)
            document.querySelector('#maintenance').style.display = 'block'
        }).catch(() => {
            // ignore
        })
    },
    destroyed () {
        this.$root.$off('loading', this.loading)
        this.$root.$off('wake', this.wake)
    },
    mounted () {
        window.addEventListener('beforeunload', (e) => {
            // Cancel the event
            if (this.uploading || this.uploadGroups.length) {
                e.preventDefault()
                // Chrome requires returnValue to be set
                e.returnValue = true
                return ''
            }
        })
    },
    methods: {
        wake (isWake) {
            if (isWake) {
                console.log('wake up')
                this.noSleep.enable()
            } else {
                console.log('sleep')
                this.noSleep.disable()
            }
        },
        loading (show) {
            if (show) {
                document.querySelector('#loading').classList.remove('d-none')
            } else {
                document.querySelector('#loading').classList.add('d-none')
            }
        }
    }
}
</script>

<style>
html {
    position: relative;
    min-height: 100%;
}

body {
    font-family: 'Noto Sans JP', sans-serif !important;
    /* Margin bottom by footer height */
    margin-bottom: 60px;
    overflow-x: hidden;
    min-height: 100%;
}

main.container-fluid {
    padding: 70px 15px 70px;
}

main.container {
    padding: 70px 15px 70px;
}

.body-no-scroll {
    overflow: hidden;
}

.swal2-toast .swal2-content {
    max-width: 400px;
}

.swal2-toast #swal2-content {
    text-align: left !important;
}

#modalSearchVideo___BV_modal_outer_ {
    z-index: 10000 !important;
}

.swal2-container {
    z-index: 9999 !important;
}
</style>
